<app-sidemenu></app-sidemenu>
<div #globalModalDirective></div>
<ngx-spinner #spinnerNg name="global">
  <p style="color: black"> Please Wait.... </p>
</ngx-spinner>
<p-toast></p-toast>
<router-outlet></router-outlet>